export default "__VITE_ASSET__m4lW94wK__"